import React, { Component } from 'react';
import TeamEstimate from './TeamEstimate.js'
import MaterialIcon from 'material-icons-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './TeamEstimateTracker.css'

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copyLinkButtonText: 'Copy'
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.roomShowTotalEstimate !== this.props.roomShowTotalEstimate)
      this.setState({ copyLinkButtonText: 'Copy' });
  }

  teamEstimate(roomStep, index) {
    return (
      <TeamEstimate
        key={index}
        type={roomStep.type}
        status={roomStep.status}
        estimate={roomStep.estimate}
        roomStepsReady={this.props.roomStepsReady}
        roomShowEstimate={this.props.roomShowEstimate}
        onRoomUpdateStepEstimate={this.props.onRoomUpdateStepEstimate}
        onRoomNextStep={this.props.onRoomNextStep}
        onRoomEstimatesReset={this.props.onRoomEstimatesReset} />
    );
  }

  render() {
    if (this.props.roomShowTotalEstimate) {
      return (
        <div className="team-estimate-tracker">
          <div className="team-total-estimate">
            <CopyToClipboard text={this.props.room.total} onCopy={() => this.setState({copyLinkButtonText: 'Copied!'})}>
              <div className="option copy">
                <MaterialIcon icon="content_copy" />
                  <div className="option-text">{this.state.copyLinkButtonText}</div>
              </div>
            </CopyToClipboard>
            <div className="estimate">
              {this.props.room.total}
            </div>
            <div className="option restart" onClick={this.props.onRoomRestart}>
              <MaterialIcon icon="refresh" />
              <div className="option-text">Restart</div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="team-estimate-tracker">
          {this.props.room.steps.map((roomStep, index) => this.teamEstimate(roomStep, index) )}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/Room/TeamEstimateTracker.js